import localizations from '../../i18n';

export const i18n = (value, locale) => {
  if (!value) {
    return '';
  }
  return localizations[locale][value] || localizations.en[value];
};
